import type { WhatsappGroup } from '@wix/ai-scheduling-assistant-common-lib/entities';
import { useTranslation } from '../../../lib/i18n';
import { modeLabelKey } from '../../settings/shared/whatsapp-group-status';

// "{n} participants · Mentions only" — the group subtitle used identically on the
// card and in the settings panel, so the two can't drift.
export function useWhatsappGroupSubtitle(): (group: WhatsappGroup) => string {
  const { t } = useTranslation();
  return (group) => {
    const count = group.participants.length;
    const key = count === 1 ? 'settings.whatsapp.group.participantsOne' : 'settings.whatsapp.group.participants';
    return `${t(key, { count })} · ${t(modeLabelKey(group.responseMode))}`;
  };
}
